import authState from 'areas/auth/state';
import cardState from 'areas/cards/state';
import competenceState from 'areas/competence/state';
import configState from 'areas/config/state';
import locationState from 'areas/location/state';
import supervisorState from 'areas/supervisor/state';
import swipeState from 'areas/swipes/state';
import themeState from 'areas/theme/state';
import videoState from 'areas/video/state';

export default [
    authState,
    cardState,
    competenceState,
    configState,
    locationState,
    supervisorState,
    swipeState,
    themeState,
    videoState
];
